var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowRightHighlighted = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "arrow-right-copy-a",
    d: "M10.1433327,4.48450649 C9.36805914,3.760719 8.20135299,3.85912039 7.53742992,4.70429409 C6.94489381,5.45858659 6.94489473,6.57106868 7.53743072,7.32536623 L11.7697127,11.9493121 L7.53743072,16.573258 C6.82085643,17.3591021 6.82085643,18.6282745 7.53743069,19.4141136 C8.2582816,20.1952955 9.42248719,20.1952955 10.1433335,19.4141137 L17,11.9493121 L10.1433327,4.48450649 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#4A90E2",
    xlinkHref: "#arrow-right-copy-a"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowRightHighlighted, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Arrow-Right-Highlighted.3149a50c.svg";
export { ForwardRef as ReactComponent };